import { useCallback } from "react";
import { eventStat } from "../api/stats";

export default function TrackedLink({ href, kingdom, phylum, children, ...props }) {
  const handleMouseDown = useCallback(
    (event) => {
      if (event.button === 0 || event.button === 1) {
        eventStat({ event: "link_click", kingdom: kingdom, phylum: phylum });
      }
    },
    [kingdom, phylum]
  );

  return (
    <a target="_blank" rel="noreferrer" href={href} onMouseDown={handleMouseDown}>
      {children}
    </a>
  );
}
